import React, { memo } from "react";
import { composeChapterUrl } from "@/utils/URL";
import Icon from "@/read-ui/Icon";
import styles from "./styles.module.scss";
import { GiftOutline, LockOutline } from "@webnovel/chereads-icons";
import type { IChapter } from "../../interfaces";
import { BookTypeEnum } from "@/interface/IBook";
import Link from "next/link";

const PIN_ELEMENT = "crt_reading_cha";

interface IChapterProps {
  chapterInfo: IChapter;
  isCurrent?: boolean;
  bookId: string;
  bookName: string;
  novelType?: BookTypeEnum;
  isPureId?: boolean;
}

const ChapterItem = ({
  chapterInfo,
  bookId,
  bookName,
  isCurrent = false,
  novelType = BookTypeEnum.Novel,
  isPureId = false,
}: IChapterProps) => {
  const { chapterIndex, chapterName, chapterId, publishTimeFormat } =
    chapterInfo;
  let showIcon;
  if (chapterInfo.isVip === 1 && chapterInfo.isAuth !== 1) {
    showIcon = GiftOutline;
  } else if (chapterInfo.isVip === 2 && chapterInfo.isAuth !== 1) {
    showIcon = LockOutline;
  } else {
    showIcon = null;
  }
  return (
    <Link
      title={chapterName}
      href={composeChapterUrl({
        bookId,
        chapterId,
        bookName,
        chapterIndex,
        novelType,
        isPureId,
      })}
      className={`${
        isCurrent ? `${PIN_ELEMENT}` : ""
      } g_hr lh24 db oh fs14 clearfix pt16 pb16 pr`}
    >
      {+chapterIndex >= 0 && (
        <i className={`fl ${styles.num} mr4 c_l`}>
          <span className={`${isCurrent ? `c_primary` : ""}`}>
            {chapterIndex}
          </span>
        </i>
      )}
      {showIcon && (
        <Icon className={`fr ml8 mt4 c_s`} Svg={showIcon} size={16} />
      )}
      <div className="oh">
        <strong
          className={`ells _3 oh fs16 mb2 lh24 c_l ${
            isCurrent ? `c_primary` : ""
          }`}
        >
          {chapterName}
        </strong>
        <small className={`db fs12 lh16 ell c_s`}>{publishTimeFormat}</small>
      </div>
    </Link>
  );
};
export default memo(ChapterItem);
